module.exports = __webpack_public_path__ + "img/primary_7x2.5b9701ed.svg";